<template>
<div class="form-step-item">
    <div class="panel">
        <h3>Alternate Contact Information</h3>
        <div class="form-row">
            <div class="form-group col-4">
                <label for="alt_contact_first_name">First name *</label>
                <input type="text" class="form-control" v-model="formData.alt_contact_first_name">
                <span class="form-error" v-if="$v.formData.alt_contact_first_name.$dirty && !$v.formData.alt_contact_first_name.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="alt_contact_last_name">Last name *</label>
                <input type="text" class="form-control" v-model="formData.alt_contact_last_name">
                <span class="form-error" v-if="$v.formData.alt_contact_last_name.$dirty && !$v.formData.alt_contact_last_name.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="alt_contact_relationship">Relationship to patient *</label>
                <input type="text" class="form-control" v-model="formData.alt_contact_relationship">
                <span class="form-error" v-if="$v.formData.alt_contact_relationship.$dirty && !$v.formData.alt_contact_relationship.required">Required field</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-4">
                <label for="alt_contact_email">Email address *</label>
                <input type="text" class="form-control" v-model="formData.alt_contact_email">
                <span class="form-error" v-if="$v.formData.alt_contact_email.$dirty && !$v.formData.alt_contact_email.required">Required field</span>
                <span class="form-error" v-if="$v.formData.alt_contact_email.$dirty && !$v.formData.alt_contact_email.email">Not a valid email</span>
            </div>
            <div class="form-group col-4">
                <label for="alt_contact_phone">Phone number *</label>
                <input type="text" class="form-control" v-model="formData.alt_contact_phone">
                <span class="form-error" v-if="$v.formData.alt_contact_phone.$dirty && !$v.formData.alt_contact_phone.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="alt_contact_phone_alt">Alternative phone number</label>
                <input type="text" class="form-control" v-model="formData.alt_contact_phone_alt">
            </div>
        </div>
    </div>
</div>
</template>


<script>

import { required, email } from 'vuelidate/lib/validators';

export default {
    name: 'FormStep2',
    components: {
    },
    props: {
        formData: {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    validations: {
        formData: {
            alt_contact_first_name: {
                required,
            },
            alt_contact_last_name: {
                required,
            },
            alt_contact_relationship: {
                required,
            },
            alt_contact_email: {
                required,
                email,
            },
            alt_contact_phone: {
                required,
            },
        },
    },
    computed: {
    },
    methods: {
        validateForm() {
            this.$v.$touch();
            this.$emit('validation_response', !this.$v.$invalid);
        },
    },
};
</script>
